import { render, staticRenderFns } from "./SummaryMoveProducts.vue?vue&type=template&id=4ed1a88c&scoped=true"
import script from "./SummaryMoveProducts.vue?vue&type=script&lang=js"
export * from "./SummaryMoveProducts.vue?vue&type=script&lang=js"
import style0 from "./SummaryMoveProducts.vue?vue&type=style&index=0&id=4ed1a88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1a88c",
  null
  
)

export default component.exports